import { memo, useMemo } from 'react';

import Typography from '@material-ui/core/Typography';

import { colors } from '../../../assets';
import { AttachmentItem } from '../attachmentItem/AttachmentItem';
import { useStyles } from './AttachmentsSection.styles';
import { AttachmentsSectionProps } from './AttachmentsSection.types';

export const AttachmentsSection = memo(
  ({
    attachments,
    selectedFile,
    hideLabel,
    required,
    loading,
    disabled,
    hasError,
    isEmpty,
    onPreview,
    onDelete,
  }: AttachmentsSectionProps) => {
    const styles = useStyles();

    const colorData = useMemo(() => (hasError ? colors.functionals.alert : colors.basic.black), [hasError]);

    return (
      <div className={styles.attachmentsSection}>
        {!hideLabel && (
          <Typography variant="body1" style={{ color: colorData, fontWeight: 'bold' }}>
            Attachments
          </Typography>
        )}

        {(attachments.length > 0 || selectedFile || loading || (!loading && isEmpty)) && (
          <div>
            {attachments.length > 0 && (
              <div className={styles.attachmentsList}>
                {attachments.map(attachment => (
                  <AttachmentItem
                    key={attachment.id}
                    name={attachment.name}
                    fileUrl={attachment.url}
                    description={attachment.description}
                    typeOfAttachment={attachment.typeOfAttachment?.name}
                    permissions={{
                      hideDelete: !(attachment.canBeDeleted ?? true),
                    }}
                    disabled={disabled}
                    onPreview={onPreview ? () => onPreview(attachment.url, attachment) : undefined}
                    onDelete={() => onDelete?.(attachment.id)}
                  />
                ))}
              </div>
            )}

            {selectedFile && (
              <AttachmentItem
                name={selectedFile.name}
                fileUrl={selectedFile.fileUrl}
                disabled={disabled}
                onDelete={selectedFile.onDelete}
              />
            )}

            {loading && (
              <Typography variant="body1" style={{ color: colorData }}>
                Loading...
              </Typography>
            )}

            {!loading && isEmpty && (
              <Typography variant="body1" style={{ color: colorData }}>
                No attachments added yet.
              </Typography>
            )}
          </div>
        )}

        {required && (
          <Typography variant="body2" style={{ color: colorData }}>
            *required
          </Typography>
        )}
      </div>
    );
  },
);
